
    import __i18nConfig from '@next-translate-root/i18n'
    import __appWithI18n from 'next-translate/appWithI18n'
    import Image from 'next/image';
import Link from "next/link";
import { Spinner } from "reactstrap";
import { Routes } from "@basics/routes";
import BaseLayout from "@components/BaseLayout";
import ForwardingPage from "@components/common/ForwardingPage";
import SponsorItem from "@components/common/SponsorComponent";
import TranslatedHtml from "@components/common/TranslatedHtml";
import { withDynamicNamespaces } from "@components/hoc/withDynamicNamespaces";
import { NamespaceShortcut, useDynamicTranslation } from "@services/i18n/i18n";
import { useCurrentProgram } from "@services/pageHelpers";
import { routeWithParams } from "@services/routesHelper";
import { SINN_PROTOTYPE_CLIENT_CONFIG_USED } from "config";
const usedNamespaces: NamespaceShortcut[] = ["program-operations"];
/**
 * this page is the front page of the app
 */
const FrontPage: React.FC = () => {
    const t = useDynamicTranslation();
    const { currentProgram, programRequest } = useCurrentProgram();
    if (SINN_PROTOTYPE_CLIENT_CONFIG_USED) {
        return <ForwardingPage targetUrl={Routes.Login}/>;
    }
    return <BaseLayout pageTitle={t("common", "page.index.title")} isFrontPage={true}>
    <div className="frontpage-content">
      <h1 aria-level={2} className="frontpage-title">{t("common", "page.index.heading")}</h1>
      <span className="frontpage-subtitle">
        <TranslatedHtml content={t("common", "page.index.quote")}/>
      </span>
      {programRequest?.isLoading
            ? <Spinner />
            : currentProgram
                ? <Link href={routeWithParams(Routes.MarketOfProjects, { id: currentProgram.id })} className="btn btn-frontpage">
            <span className="title">{t("goto", "marketplace")}</span>
            {t("common", "page.index.button")}
          </Link>
                : <div className="btn btn-frontpage">{t("program-operations", "noProgram")}</div>}
    </div>
    <div className="sponsors">
      <SponsorItem>
        <Image src="/assets/img/sinn-sachsen/EU-Logo.png" alt="Sponsored by EU" width="175" height="35" priority/>
      </SponsorItem>
    </div>
  </BaseLayout>;
};
const __Next_Translate__Page__19afd9c6d64__ = withDynamicNamespaces(FrontPage, usedNamespaces);

    export default __appWithI18n(__Next_Translate__Page__19afd9c6d64__, {
      ...__i18nConfig,
      isLoader: true,
      skipInitialProps: false,
      loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
    });
  